<template>
  <van-nav-bar
    @click-left="onClickLeft"
    :border="border"
    :title="title"
    :left-arrow="leftArrow"
  >
    <template #left>
      <slot name="left">
        <img src="../../assets/img/page/Frame.png" alt="" style="width: 28px;height: 28px">
      </slot>
    </template>
    <template #title>
      <slot name="title"></slot>
    </template>
    <template #right>
      <slot name="right"></slot>
    </template>
  </van-nav-bar>
</template>

<script>
export default {
  name: "vHeader",
  props: {
    title: {
      default: "",
      type: String,
      required: false,
    },
    leftArrow: {
      default: true,
      type: Boolean,
      required: false,
    },
    leftClick: {
      default: undefined,
      type: Function,
      required: false,
    },
    border: {
      default: true,
      type: Boolean,
      required: false,
    },
    forceFlag: {
      default: false,
      type: Boolean,
      required: false,
    },
  },
  methods: {
    onClickLeft() {
      if (this.leftClick) {
        this.leftClick();
       
      } else {
        // 由于没有登录，强制跳转，返回到首页
        if (this.forceFlag) {
          this.$router.push("/");
    
        } else {
          history.back();
         
          // this.$router.go(-1);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .van-nav-bar__left,
/deep/ .van-nav-bar__right {
  padding: 0 !important;
}
.van-nav-bar{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 0px 10px;
  // bottom:10px;
//  padding-bottom: 40px;
}
</style>